import React, { useEffect } from 'react';
import clsx from 'clsx';

import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

import useStyles from './styles';
import { SidebarItemChildrenType, SidebarItemType } from 'src/interfaces/idashboard';
import { SidebarOptionType } from 'src/interfaces/iproptypes';
import { sampleMarket, sidebarClosedWidth, sidebarWidth } from 'src/utils/const';
import { useSelector } from 'react-redux';
import postOnSlack from 'src/core/postOnSlack';
import { COLOR_PRIMARY_2, DEFAULT_TEXT_COLOR } from 'src/utils/colors';
import { useHistory } from 'react-router-dom';
import { openSidebarRedirectionLink } from './sidebarLinkUtils';

const SidebarOption = ({
  item,
  isSubGroup,
  handleSidebarClick,
  handleSidebarListItemClick,
  matches,
  sidebarOpen,
  setSidebarOpen,
  index: _childIndex,
  selectedSidebarIndex,
  isExpanded,
  setIsExpanded,
  isFlyoutParent,
  isOptionGroupSelected,
  user,
  setOpenReportComparePage,
}: SidebarOptionType) => {
  const classes = useStyles();
  const pathname = window.location.pathname;
  const estimatorSearchAddress = useSelector(
    state => (state as any).dashboard.estimatorSearchMarket
  );

  const history = useHistory();

  useEffect(() => {
    if (sidebarOpen === false) {
      setIsExpanded && setIsExpanded(false);
    } else {
      item.name === 'Calculator' && setIsExpanded && setIsExpanded(false);
    }

    if (
      item.name === 'Calculator' &&
      (pathname === '/airbnb-calculator' ||
        pathname === '/airbnb-calculator/' ||
        pathname === '/my-analysis' ||
        pathname === '/my-analysis/')
    ) {
      setIsExpanded && setIsExpanded(true);
    }
  }, [sidebarOpen, pathname, estimatorSearchAddress]);

  const isRowSelected =
    item.listIndex === selectedSidebarIndex || (!!isFlyoutParent && !!isOptionGroupSelected);

  const sendSlackNotification = clickedItem => {
    postOnSlack(
      'C05JDGPMH8T',
      `User: ${user.email} clicked on ${clickedItem} Button In the App SideBar`
    );
  };

  return (
    <ListItem
      button
      classes={{
        root: clsx(classes.sideBar, isSubGroup && classes.sidebarNestedOption),
      }}
      onClick={() => {
        if (
          item.name === 'Custom Data' ||
          item.name === 'API' ||
          item.name === 'Property-level Performance Data' ||
          item.name === 'Enterprise'
        ) {
          sendSlackNotification(item.name);
        }

        setOpenReportComparePage && setOpenReportComparePage(false);

        if (item.name === 'Calculator') {
          history.push('/airbnb-calculator');
        }

        if (item.redirectionLink) {
          openSidebarRedirectionLink(item.redirectionLink, history);
          return;
        }

        if (item.stateName) {
          handleSidebarClick && handleSidebarClick(item.stateName);
          handleSidebarListItemClick(item.listIndex);
          if (matches) {
            setSidebarOpen(false);
          }
        }

        if (
          (window.location.pathname == '/airbnb-data' ||
            window.location.pathname == '/airbnb-data/' ||
            window.location.pathname == '/') &&
          item.listIndex === 4
        ) {
          window.open(`/airbnb-data/united-kingdom/0/${sampleMarket}?guests=true`, '_self');
        } else {
          if (isExpanded) {
            setIsExpanded && setIsExpanded(false);
          } else {
            setIsExpanded && setIsExpanded(true);
          }
        }
      }}
      style={{
        marginLeft: 0,
        paddingTop: 0,
        paddingBottom: 0,
      }}
    >
      <ListItemIcon
        style={{
          minWidth: 0,
          padding: 0,
          display: 'flex',
          justifyContent: isSubGroup ? 'flex-start' : 'center',
          width: '100%',
        }}
      >
        <Stack
          direction={matches ? 'row' : 'column'}
          justifyContent={isSubGroup ? 'flex-start' : 'center'}
          alignItems={isSubGroup ? 'stretch' : 'center'}
          spacing={0}
          sx={{
            background: (() => {
              if (isSubGroup) {
                return item.listIndex === selectedSidebarIndex ? COLOR_PRIMARY_2 + '14' : 'transparent';
              }
              if (isFlyoutParent && isExpanded && !isOptionGroupSelected) {
                return 'rgba(15, 23, 42, 0.07)';
              }
              return isRowSelected ? COLOR_PRIMARY_2 + '14' : 'transparent';
            })(),
            padding: isSubGroup ? '7px 10px' : '5px 4px',
            borderRadius: isSubGroup ? '8px' : '12px',
            maxWidth: isSubGroup ? '100%' : matches ? sidebarWidth : sidebarClosedWidth,
            width: '100%',
            margin: matches ? undefined : 'auto',
            boxSizing: 'border-box',
            transition: 'background-color 0.15s ease',
          }}
        >
          {(item as SidebarItemType)?.icon &&
            React.cloneElement((item as SidebarItemType).icon, {
              style: {
                ...(isSubGroup
                  ? item.listIndex === selectedSidebarIndex
                  : isRowSelected)
                  ? { color: COLOR_PRIMARY_2 }
                  : { color: '#000' },
                ...(matches ? {} : { marginBottom: '4px' }),
              },
            })}

          {/* {sidebarOpen && ( */}
          <>
            {isSubGroup && (item as SidebarItemChildrenType).tooltip ? (
              <Tooltip title={(item as SidebarItemChildrenType).tooltip!} placement="right" arrow>
                <span
                  style={{
                    display: 'block',
                    width: '100%',
                    maxWidth: isSubGroup ? '100%' : sidebarClosedWidth,
                  }}
                >
                  <ListItemText
                    id={item.listIndex == 11 ? 'searchTab' : ''}
                    classes={{
                      primary: isSubGroup
                        ? item.listIndex === selectedSidebarIndex
                          ? classes.sidebarNestedTextSelected
                          : classes.sidebarNestedText
                        : isRowSelected
                          ? classes.sidebarTextSelected
                          : classes.sidebarText,
                    }}
                    primary={item.name}
                    style={{
                      maxWidth: isSubGroup ? '100%' : sidebarClosedWidth,
                      textAlign: isSubGroup || matches ? 'left' : 'center',
                    }}
                  />
                </span>
              </Tooltip>
            ) : (
              <ListItemText
                id={item.listIndex == 11 ? 'searchTab' : ''}
                classes={{
                  primary: isSubGroup
                    ? item.listIndex === selectedSidebarIndex
                      ? classes.sidebarNestedTextSelected
                      : classes.sidebarNestedText
                    : isRowSelected
                      ? classes.sidebarTextSelected
                      : classes.sidebarText,
                }}
                primary={item.name}
                style={{
                  maxWidth: isSubGroup ? '100%' : sidebarClosedWidth,
                  textAlign: isSubGroup || matches ? 'left' : 'center',
                }}
              />
            )}
            {/* {item?.chipLabel && <div className={classes.betaButton}>{item.chipLabel}</div>} */}
            {item.isBeta && <div className={classes.betaButton}>Beta</div>}
          </>
          {/* )}  */}

          {!item.isPage &&
            item.children?.length > 0 &&
            !isFlyoutParent &&
            sidebarOpen &&
            (isExpanded ? (
              <KeyboardArrowDownRoundedIcon
                sx={{
                  float: 'right',
                  color: DEFAULT_TEXT_COLOR,
                }}
              />
            ) : (
              <ChevronRightRoundedIcon
                sx={{
                  float: 'right',
                  color: DEFAULT_TEXT_COLOR,
                }}
              />
            ))}
        </Stack>
      </ListItemIcon>
    </ListItem>
  );
};

export default SidebarOption;
